/**
 * Animations
 */

// viewport-based animations
export const ani = (els) => {
	if (els.length && window.IntersectionObserver) {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					entry.target.classList.toggle('is-shown', entry.isIntersecting)
				})
			},
			{ rootMargin: '10px 0px 0px' }
		)

		els.forEach((el) => {
			observer.observe(el)
		})
	}
}

// on load animations
export const aniOnLoad = (els) => {
	if (els.length) {
		// show the element after a bit if it's already cached
		if (els.complete) {
			setTimeout(() => {
				els.classList.add('is-shown')
			}, 100)
			// show the element after it loads for the first time
		} else {
			els.addEventListener('load', () => {
				els.classList.add('is-shown')
			})
		}
	}
}

// set up animations
export const aniSetup = (selector, childSelectors) => {
	const els = document.querySelectorAll(selector)
	if (els.length) {
		const childrenEls = []
		els.forEach((el) => {
			// if there are child animations
			const children = el.querySelectorAll(childSelectors.join(','))
			if (children.length) {
				children.forEach((childEl, i) => {
					// transfer the animation to the child
					childEl.classList.add('ani')
					childEl.classList.remove('ani-able')
					// stagger animations slightly
					childEl.style.setProperty('--ani-delay', i)
					// add this child to the list for animating
					childrenEls.push(childEl)
				})
				// remove animation from parent
				el.classList.remove('ani')
			}
		})
		// apply animations
		ani([...els, ...childrenEls])
	}
}
